import axios, { AxiosInstance } from 'axios';

import { addMaintenanceRedirectInterceptor } from '@gmm/problem';

import { getConfig } from '../../environmentConfig';

import { convertStringToBool } from './utils';

export const configureAxios = (): void => {
  configureAxiosInstance(axios);
};

export const configureAxiosInstance = (instance: AxiosInstance): void => {
  Promise.resolve(getConfig()).then(config => {
    instance.defaults.baseURL = config.JAVA_URL;
    instance.defaults.headers.post['Content-Type'] =
      'application/x-www-form-urlencoded';

    addMaintenanceRedirectInterceptor(instance, response => {
      if (response.data) {
        response.data = convertStringToBool(response.data);
      }

      return response;
    });
  });
};
